import CustomerResidence from './CustomerResidence';

export default class CustomerHousing {
	currentResidence?: CustomerResidence;
	previousResidence: CustomerResidence = new CustomerResidence();
	//TODO: Remove this once we have a previousResidence property copied over from applications
	mortgageRentPayment?: string = null;
	movedInDate: Date = null;
	constructor(init?: Partial<CustomerHousing>) {
		if (init) {
			this.currentResidence = init.currentResidence;
			this.previousResidence = init.previousResidence;
			this.mortgageRentPayment = init.mortgageRentPayment;
			this.movedInDate = init.movedInDate;
		}
	}
}
